import { type JSX } from 'react'

import { DialogTitle } from 'base-ui'

type NewsletterModalTitleProps = {
  onModalClose: () => void
}

export const NewsletterModalTitle = ({
  onModalClose,
}: NewsletterModalTitleProps): JSX.Element => {
  return (
    <div className="relative">
      <DialogTitle
        className="absolute right-3 top-3 bg-transparent p-0"
        onClose={onModalClose}
        slotProps={{
          closeButton: {
            className: 'fill-current',
          },
        }}
      />
    </div>
  )
}
